export const nl = {
  translation: {
    "Belimo Energy Valve": "Belimo Energy Valve",
    Yes: "Ja",
    No: "Nee",
    "You cannot go back from this position":
      "U kunt niet terug vanaf deze positie",
    Chapters: "Hoofdstukken",
    Start: "Start",
    "Connecting to the Energy Valve":
      "Verbinden met de Energy Valve",
    "Control Source": "Aansturingbron",
    "Do you know the design flow rate?":
      "Weet u wat het debiet van de uitvoering is?",
    "Flow Control": "Debietregeling",

    "Is the building running off fixed or varying flow temperatures?":
      "Werkt het gebouw met vaste of variabele debiettemperaturen?",

    "Varying flow temperatures (Delta T Manager Scaling)":
      "Variabele debiettemperaturen (Delta T-manager geschaald)",

    "Fixed flow temperatures (Delta T Manager)":
      "Vaste debiettemperaturen (Delta T-manager)",

    "I am not sure": "Weet ik niet zeker",
    "Delta T Manager": "Delta T-manager",
    Scaling: "Geschaald",
    "Do you know the power output?":
      "Weet u wat de vermogensafgifte is?",
    "Yes (Power Control)": "Ja (vermogensregeling)",
    "No (Position Control)": "Nee (positieregeling)",
    "Power Control": "Vermogensregeling",
    "Position Control": "Positieregeling",
    "Onboard Data Analysis": "Ingebouwde gegevensanalyse",

    "Did you get a clear result from the Energy Valve?":
      "Gaf de Energy Valve een duidelijk resultaat?",

    "How do you want to setup your Energy Valve?":
      "Hoe wilt u uw Energy Valve instellen?",

    "Would you like to connect to the cloud?":
      "Wilt u verbinding maken met de cloud?",

    "Cloud Connectivity": "Cloudconnectiviteit",

    "Onboard Diagnostics / Download Data":
      "Ingebouwde diagnose / Gegevens downloaden",

    "Download Data": "Gegevens downloaden",
    "Send optimization request":
      "Aanvraag voor optimalisatie verzenden",
    End: "Einde",

    Subtitles: "Ondertitels",
    Repeat: "Herhaal",
    Continue: "Ga door",
  },
};
